import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { errorState } from "../../recoil/error/atom";
import { deleteCurrentCandidate } from "../../requests/candidates";
// import { DropdownList } from "react-widgets";
// import { toastMessageState } from "../../recoil/toast/atom";

export default function Admin() {
  const popError = useSetRecoilState(errorState);
  // const popToast = useSetRecoilState(toastMessageState);
  const { t } = useTranslation();
  const onSubmit = () => {
    deleteCurrentCandidate().then(() => {
      window.location = "/jobs/user/logout";
    });
  };
  const popAlert = () => {
    // popToast([{
    //   type: "success",
    //   title: t("Form.Candidate.Admin.Delete.Confirm.Title")
    // }]);
    popError([
      {
        type: "warning",
        title: t("Form.Candidate.Admin.Delete.Confirm.Title"),
        message: t("Form.Candidate.Admin.DeleteConfirmation"),
        confirmBtnText: t("Action.DeleteProfile"),
        showCancel: true,
        confirmBtnBsStyle: "danger",
        cancelBtnBsStyle: "default",
        onConfirm: onSubmit,
      },
    ]);
  };

  return (
    <div className={"btn btn-border"}>
      <Button
        variant="warning"
        type="button"
        onClick={() => {
          popAlert();
        }}>
        {t("Menu.Admin.Mobile")}
      </Button>
    </div>
  );
}
